export const getOperatorById = (operators, operatorId) => {
    return operators[operatorId];
};

export const getOperatorsByChannelId = (operators, channelOperatorIds, channelId) => {
    return channelOperatorIds[channelId]?.map((id) => operators[id]);
};
